// @Version: 1.0.0
import { Injectable } from "@angular/core"
import { FormGroup,  ValidationErrors, ValidatorFn } from "@angular/forms"
import { FC_TOGGLE } from "./toggle.model";
import { IFieldItem } from "../field-item.model";

@Injectable({
   providedIn: 'root'
})

export class CustomValidatorsToggle {

   constructor () {}

   public isValid (fg: FormGroup, fieldItem: IFieldItem): ValidatorFn {
      return (): ValidationErrors | null => {
         if ((!fg.value[FC_TOGGLE.TOGGLEBUTTON] || fg.value[FC_TOGGLE.TOGGLEBUTTON] && fg.value[FC_TOGGLE.TOGGLEBUTTON].length == 0)) return null;
         if (!fieldItem.valid || fieldItem.valid.length == 0) return null;
         const valid =  fieldItem.valid.split(';');
         if (valid.length == 0) return null;
         return valid.findIndex(item => fg.value[FC_TOGGLE.TOGGLEBUTTON] == item ) > -1 ?  null : { valid: true };
      }
   }

   public isRequired (fg: FormGroup): ValidatorFn {
      return (): ValidationErrors | null => {
         return (fg.value[FC_TOGGLE.TOGGLEBUTTON] == null || fg.value[FC_TOGGLE.TOGGLEBUTTON] == undefined || fg.value[FC_TOGGLE.TOGGLEBUTTON] == '' || fg.value == '' || fg.value == undefined ||  fg.value == null ) ? { required: true } : null;
      }
   }    
}